import {Component} from '@angular/core';
import {FormControl, FormGroup, ValidationErrors, Validators,} from '@angular/forms';
import {ToastService} from '../../../modules/toast/toast.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
    serverError: ValidationErrors;
    formKeys = {
        email: 'email',
        password: 'password',
    };
    loginForm: FormGroup = new FormGroup({
        [this.formKeys.email]: new FormControl('', [Validators.required]),
        [this.formKeys.password]: new FormControl('', [Validators.required]),
    });
    isAuthenticating = false;
    private token: string;

    constructor(private toastService: ToastService, private dialog: MatDialog) {
    }

    get hasToken() {
        return Boolean(this.token);
    }

    get canLogin() {
        return this.loginForm.valid && this.hasToken;
    }

    onSubmit(): void {
        this.login(this.loginForm.value);
    }


    getError(controlName: string) {
        const errors = Object.keys(
            this.loginForm.controls[controlName].errors || {}
        );
        return errors[0] || '';
    }

    login(credentials: { email: string; password: string }) {


    }

    onResolve(token: string) {
        this.token = token;
    }


}
